import { createClient } from "@supabase/supabase-js";

const supabase = createClient(
  process.env.REACT_APP_SUPABASE_URL,
  process.env.REACT_APP_SUPABASE_ANON_KEY
);

const FRONTEND_DOMAIN = process.env.REACT_APP_FRONTEND_DOMAIN;

export const login = async () => {
  const { error } = await supabase.auth.signInWithOAuth({
    provider: "discord",
    options: {
      redirectTo: `${FRONTEND_DOMAIN}/user/profile`,
      scopes: 'identify guilds',
    },
  });

  if (error) console.error("Login error:", error);
};

export const logout = async () => {
  const {error} = await supabase.auth.signOut();
  if (error) console.error("Logout error:", error);
};

export { supabase };
